export default class Header {
  constructor() {
    this.header = '#header'
    this.$header = $(this.header)
    this.numberScroll = 0
    this.scrollTop = 0
    this.class = 'pin-header'
    this.$isOpenSearch = $('.is-open-search')
    this.lastScrollTop = window.pageYOffset || document.documentElement.scrollTop
    this.$searchHeader = $('.search-header')
  }

  init() {
    if (this.$header.length) {
      this.scrollPinHeader()
      this.openSearchHeader()
      this.clickOutSite()
      this.scrollCloseSearch()
    }
  }

  scrollPinHeader() {
    this.settingPin()
    $(window).on('scroll resize orientationchange', () => {
      this.settingPin()
    })

    window.addEventListener('scroll', () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > this.lastScrollTop && scrollTop > this.$header.height()) {
        // Scrolling down
        this.$header.addClass('is-hide-header')
      } else {
        // Scrolling up
        this.$header.removeClass('is-hide-header')
      }

      this.lastScrollTop = scrollTop;
    });
  }

  settingPin() {
    this.scrollTop = $(window).scrollTop()
    if (this.scrollTop > this.numberScroll) {
      this.$header.addClass(this.class)
    } else {
      this.$header.removeClass(this.class)
    }
  }

  openSearchHeader() {
    this.$isOpenSearch.on('click', () => {
      if (this.$searchHeader.hasClass('is-open')) {
        this.$searchHeader.removeClass('is-open')
      } else {
        this.$searchHeader.addClass('is-open')
        setTimeout(() => {
          this.$searchHeader.find('input').focus()
        }, 300)
      }
    })
  }

  clickOutSite() {
    $(document).on('click', (event) => {
      if (!$(event.target).closest(this.header).length && !$(event.target).closest('.is-open-search').length) {
        this.$searchHeader.removeClass('is-open')
      }
    })
  }

  scrollCloseSearch() {
    $(window).on('scroll', () => {
      this.$searchHeader.removeClass('is-open')
    })
  }
}

new Header().init()
